<template>
  <div class="layout-footer">
    <!-- Manejo de Versiones de la Aplicación: TILUCHI 1 => Identifica los cambios -->
    <!-- generales y la inclusión de nuevos módulos al SOFTWARE. 2 => Identifica la -->
    <!-- inclusión de nuevas funcionalidades a módulos existentes. 3 => Identifica la -->
    <!-- solución a errores para permitir el correcto funcionamiento del SOFTWARE. -->

    <a href="https://sitbolivia.com/" target="_blank"
      ><strong> SIT-BOLIVIA VERSI&Oacute;N: </strong>
      <span class="version-badge">
        {{ version }}
      </span>
    </a>
  </div>
</template>

<script>
export default {
  name: "AppFooter",
  data() {
    return {
      version: process.env.VUE_APP_VERSION || "1.0.0",
    };
  },
  computed: {
    darkTheme() {
      return this.$appState.darkTheme;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/demo/badges.scss";

.layout-footer {
  background-color: #f8f9fa;
  border-top: 1px solid #002236;
  
}
.layout-footer a {
  color: #002236;
  text-decoration: none;
}

.layout-footer a:hover {
  text-decoration: underline;
}

.version-badge {
  background-color: #002236;
  color: white;
  padding: 2px 4px;
  border-radius: 4px;
  font-weight: bold;
}
</style>
